import styled from 'styled-components';
import { media } from '../../../style/media';
import { white } from '../../../style/colors';
import { PageDescription } from './Layout.style';

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  cursor: default;
  opacity: 1;
  visibility: visible;
`;

export const ModalContent = styled.div`
  background: ${white};
  border-radius: 12px;
  padding: 32px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  z-index: 1001;
  cursor: default;

  ${media.s`
    padding: 24px;
  `}
`;

export const ModalHeader = styled.div`
  margin-bottom: 24px;

  ${PageDescription} {
    margin-top: 8px;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0;

  ${media.s`
    font-size: 20px;
  `}
`;

